import { useState } from 'react';
import * as patenteApiService from '../services/patenteApiService';

const useConsultaPatente = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(false); // Estado para sistema deshabilitado

  const consultarPatente = async (patente, method = 'auto') => {
    setLoading(true);
    setError(null);

    try {
      // Usar el servicio de patente que maneja toda la lógica
      const resultado = await patenteApiService.consultarPatente(patente, method);
      
      // Verificar si el sistema está deshabilitado
      if (resultado.disabled) {
        //console.log('🔒 [useConsultaPatente] Sistema de consulta deshabilitado');
        setDisabled(true);
        setError('Sistema no disponible');
        
        return {
          ...resultado,
          requiresManualInput: true
        };
      }
      
      // Si hay error en el resultado, establecerlo en el estado
      if (!resultado.success && resultado.error) {
        setError(resultado.error);
      }
      
      setDisabled(false);
      return resultado;
      
    } catch (err) {
      console.error('Error en hook consultarPatente:', err);
      
      const errorMessage = err.message || 'Error al consultar patente';
      setError(errorMessage);
      
      return { 
        found: false,
        success: false,
        error: errorMessage,
        requiresManualInput: true,
        patente: patente?.toUpperCase() || ''
      };
    } finally {
      setLoading(false);
    }
  };

  const crearClienteVehiculo = async (clienteData, vehiculoData) => {
    setLoading(true);
    setError(null);

    try {
      // Usar el servicio para crear cliente y vehículo
      const resultado = await patenteApiService.crearClienteVehiculo(clienteData, vehiculoData);
      
      // Si hay error en el resultado, establecerlo en el estado
      if (!resultado.success && resultado.error) {
        setError(resultado.error);
      }
      
      return resultado;
      
    } catch (err) {
      console.error('Error en hook crearClienteVehiculo:', err);
      
      const errorMessage = err.message || 'Error al crear cliente y vehículo';
      setError(errorMessage);
      
      return { 
        success: false,
        error: errorMessage
      };
    } finally {
      setLoading(false);
    }
  };

  return { 
    consultarPatente, 
    crearClienteVehiculo,
    loading, 
    error,
    disabled, // Nuevo estado para saber si el sistema está deshabilitado
    isEnabled: !disabled // Estado derivado para facilitar el uso
  };
};

export default useConsultaPatente;